import { type PartnerTier } from "./partnerTiers.ts";

export const partnerTierStripeColors: Record<PartnerTier, { light: string; dark: string }> = {
    Standard: {
        light: "var(--hop-primary-surface-weak-press)",
        dark: "var(--hop-primary-surface-weak-press)"
    },
    Premier: {
        light: "var(--hop-iris-400)",
        dark: "var(--hop-iris-200)"
    },
    Elite: {
        light: "var(--hop-iris-700)",
        dark: "var(--hop-iris-75)"
    }
};
